import React from 'react'
import { Modal } from 'react-bootstrap';
import postscheduleimage from '../../images/post-schedule.png';
import { Link } from 'react-router-dom';
import moment from 'moment';

const PostSchedule = (props) => {
    return (
      <Modal className="postschedule-modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        
      </Modal.Header>
      <Modal.Body>
        <div className="post-success-body">
            <h2>Great! Your post is been scheduled for {moment(props.publisedTime).format("MMMM Do YYYY, h:mm a")}</h2>
            <div className="modal-image">
                <img src={postscheduleimage} alt="published post image" />
            </div>
            <div className="dashboard-btn">
                <Link to="/posts" className="button">
                  Go to Posts
                </Link>
            </div>
        </div>
      </Modal.Body>
     
    </Modal>
    )
}

export default PostSchedule
